<textarea
  #autosizeTitle="cdkTextareaAutosize"
  cdkAutosizeMaxRows="5"
  cdkAutosizeMinRows="1"
  cdkTextareaAutosize
  class="tt-title-description_title"
  [attr.data-testid]="'title-description-component_title' + (testId() ? '-' + testId() : '')"
  [disabled]="readonly()"
  [ngModel]="title()"
  [placeholder]="'SetTitle' | transloco"
  (ngModelChange)="onTitleChange($event)"></textarea>

@if (!disableDescription()) {
  <div class="tt-title-description_description">
    <common-rich-text-editor
      id="sidebar-content--description"
      [attr.data-testid]="'title-description-component_description' + (testId() ? '-' + testId() : '')"
      [disableImageUpload]="true"
      [placePopupsToBottomLeft]="true"
      [(editorContent)]="description" />
  </div>

  @if (showCheckbox()) {
    <common-checkbox
      size="small"
      variant="primary"
      [attr.data-testid]="'title-description-component_checkbox' + (testId() ? '-' + testId() : '')"
      [(ngModel)]="showDescription">
      {{ 'Flowchart.ShowDescription' | transloco }}
    </common-checkbox>
  }
}
